import React from 'react';
import Web3Utils from 'web3-utils';
import Form from 'react-validation/build/form';
import Textarea from 'react-validation/build/textarea';
import Button from 'react-validation/build/button';
import { form, control, button } from 'react-validation';
import { inject, observer } from "mobx-react";
import swal from 'sweetalert';
import generateElement from '../generateElement'
import Example from './example.json'
import { PulseLoader} from 'react-spinners';
import {RadioGroup, Radio} from 'react-radio-group';
import csvtojson from 'csvtojson'
import Select from 'react-select'
import '../assets/stylesheets/react-select.min.css';


const ownInput = ({ error, isChanged, isUsed, ...props }) => (
  <div>
    {isChanged && isUsed && error}
    <input {...props} />
  </div>
);
const Input = control(ownInput);

const required = (value) => {
  if (!value.toString().trim().length) {
    return <span className="error">required</span>;
  }
};

const isAddress = (value) => {
  if (!Web3Utils.isAddress(value)) {
    return <span className="error">Token address is invalid</span>;
  }
};
const InvalidJSON = <div>Your JSON is invalid, please visit <a href="https://jsonlint.com/" target="_blank">Online Json Validator</a></div>

const isJson = (value) => {
  try {
    JSON.parse(value)
  } catch(e) {
    return InvalidJSON
  }
};

//jACKY
const csvExample = 
`0x1df62f291b2e969fb0849d99d9ce41e2f137006e, 12.34
0x3e5e9111ae8eb78fe1cc3bb8915d5d461f3ef9a9, 23.789
0x28a8746e75304c0780e011bed21c72cd78cd535e, 3.026
0x00fC79F38bAf0dE21E1fee5AC4648Bc885c1d774, 55.5`

const jsonExample = JSON.stringify(Example)

@inject("UiStore")
@observer
export class FirstStep extends React.Component {
  constructor(props){
    super(props);
    this.tokenStore = props.UiStore.tokenStore;
    this.txStore = props.UiStore.txStore;
    this.web3Store = props.UiStore.web3Store;
    this.web3Store.setStartedUrl('#/');
    this.onTokenAddress = this.onTokenAddress.bind(this);
    this.onDecimalsChange = this.onDecimalsChange.bind(this);
    this.onJsonChange = this.onJsonChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state ={
      format: 'csv',
      placeholder: csvExample,
      tokenAddress: {label: '', value: null},
    }
    this.onSelectFormat = this.onSelectFormat.bind(this)
    this.onParse = this.onParse.bind(this)
    this.parseCompleted = false;
    this.list = [];
    this.onPopulateSampleData = this.onPopulateSampleData.bind(this)
    this.onUploadData = this.onUploadData.bind(this)
    this.onFileChange = this.onFileChange.bind(this)
    this.onClearData = this.onClearData.bind(this)
  }

  async componentDidMount() {
    const lastTokenAddress = this.tokenStore.tokenAddress
    this.tokenStore.reset()
    this.txStore.reset()
    
    //console.log('last token address => ', lastTokenAddress)
    if(lastTokenAddress){
      await this.tokenStore.setTokenAddress(lastTokenAddress)
      const token = this.web3Store.getUserToken(lastTokenAddress)
      //console.log('token => ', token)
      if(token){
        this.setState({tokenAddress: token})
      }
    }
    if(this.web3Store.taskList){
      await this.onCsvChange(this.web3Store.taskList)
    }
  }
  async onTokenAddress(e){
    if(!e){
      this.setState({tokenAddress: {label: '', value: ''}})
      this.web3Store.setTaskList('')
      return
    }
    const address = e.value;
    if (Web3Utils.isAddress(address)) {
        await this.tokenStore.setTokenAddress(address);
        this.setState({tokenAddress: {label: e.label, value: e.value}})
        this.web3Store.setTaskList('')
    }
  }
  onSelectFormat(newFormat){
    this.parseCompleted = false;
    if(newFormat === 'csv'){
      this.setState({format: newFormat, placeholder: csvExample})
  /*
    swal("Information", `Please provide CSV file in comma separated address,balance format one line per address.
    \nExample:\n 
0xCBA5018De6b2b6F89d84A1F5A68953f07554765e,12
0xa6Bf70bd230867c870eF13631D7EFf1AE8Ab85c9,113.45
0x00b5F428905DEA1a67940093fFeaCeee58cA91Ae,1.049
0x00fC79F38bAf0dE21E1fee5AC4648Bc885c1d774,14546
    `, 'info')
    */
    } else {
      this.setState({format: newFormat, placeholder: jsonExample})
      /*
      swal({
        content: generateElement(`<div style="color:black;">
        Please provide JSON-array file in the following format.
        \nExample:\n 
        <div style="font-size: 12px;color:purple;">
        [<br/>
          {"0xCBA5018De6b2b6F89d84A1F5A68953f07554765e":"12"},
          {"0xa6Bf70bd230867c870eF13631D7EFf1AE8Ab85c9":"1123.45645"},
          {"0x00b5F428905DEA1a67940093fFeaCeee58cA91Ae":"1.049"},
          {"0x00fC79F38bAf0dE21E1fee5AC4648Bc885c1d774":"14546"}
          <br/>]
        </div>
        </div>
        `),
        icon: 'info'
      })
      */
    }
  }
  onDecimalsChange(e) {
    this.tokenStore.setDecimals(e.target.value)
  }

  onJsonChange(value) {
    try {
      let addresses = JSON.parse(value);
      this.tokenStore.setJsonAddresses(addresses)
      this.parseCompleted = true;
    } catch(e) {
      const error = e.message.replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t');
      console.error(error)
      swal({
        content: generateElement(`${error} Please visit <a target="_blank" href="https://jsonlint.com">JsonLint.com</a>`),
        icon: "error",
      })
    }
  }

  async onCsvChange(value){
    return new Promise((res, rej) => {
      let addresses = [];
      csvtojson({noheader:true})
      .fromString(value)
        .on('csv',(csv)=>{
          let el = {};
          if(csv.length === 2){
            Object.defineProperty(el, csv[0], {
              value: csv[1],
              writable: true,
              configurable: true,
              enumerable: true,
            });
            addresses.push(el)
          } 
        })
        .on('end', () => {
          try {
            console.log('csv is done')
            this.parseCompleted = true;
            this.web3Store.setTaskList(value)
            this.tokenStore.setJsonAddresses(addresses)
            res(addresses);
          } catch(e) {
            console.error(e)
            rej(e);
            swal({
              content: "转账数据无效",
              icon: "error",
            })
          }
        })
    })
  }

  onParse(e){
    this.list = e.target.value;
    if(this.state.format === 'json') {
      this.onJsonChange(e.target.value)
    }
    if(this.state.format === 'csv'){
      this.onCsvChange(e.target.value)
    }
    return
  }
  async onPopulateSampleData(e){
    e.preventDefault()
    this.web3Store.setTaskList(csvExample)
    await this.onCsvChange(csvExample)
  }
  async onUploadData(e){
    e.preventDefault()
    this.refs.uploadButton.click()
  }
  async onFileChange(e){
    //console.log(e.target.files)
    if(!e.target.files || e.target.files.length === 0) return
    const file = e.target.files[0]
    const reader = new FileReader()
    reader.onload = async e => {
      //console.log(e.target.result)
      const content = e.target.result
      this.web3Store.setTaskList(content)
      await this.onCsvChange(content)      
    }
    reader.readAsText(file)
  }
  onClearData(e){
    e.preventDefault()
    this.web3Store.setTaskList('')
  }
  async onSubmit(e){
    try {
      e.preventDefault()
      
      //jACKY
      if(!this.web3Store.defaultAccount){
        await this.web3Store.connectWallet()
        await this.tokenStore.setAccountData(this.state.tokenAddress.value);
      }
      
      if(this.state.format === ''){
        swal("Error!", "Please select format CSV or JSON", 'error')
        return
      }
      
      if(!this.parseCompleted){
        if(this.state.format === 'json') {
          this.onJsonChange(this.list)
        } else {
          await this.onCsvChange(this.list)
        }
      }
      await this.tokenStore.parseAddresses()
      console.log('length of addresses', this.tokenStore.jsonAddresses.length)
      if(this.tokenStore.jsonAddresses.length === 0){
        swal({
          title: "转账数据清单为空",
          text: "请检查输入的转账数据清单内容与格式是否正确",
          icon: "error",
        })
        return
      }
      if(this.tokenStore.invalid_addresses.length > 0){
        swal({
          title: "存在无效的以太坊地址。如果你继续下一步操作，将忽略该地址所在行的转账数据。",
          text: JSON.stringify(this.tokenStore.invalid_addresses.slice(), null, '\n'),
          icon: "error",
        })
      } else {
        this.props.history.push('/3')
      }
    } catch(e) {
      console.error(e)
      swal({
        title: "数据解析错误",
        text: e.message,
        icon: "error",
      })
    }
    return
  }
  render () {
    if(this.tokenStore.errors.length > 0){
      swal("错误!", this.tokenStore.errors.toString(), 'error')
    }
    if(this.web3Store.errors.length > 0){
      swal("错误!", this.web3Store.errors.toString(), 'error')
    }
    return (
      <div className="container container_bg">
          
        <div className="content">
          <div className='sweet-loading'>
          <PulseLoader
            color={'#123abc'} 
            loading={this.web3Store.loading} 
            />
          </div>
          <h1 className="title">欢迎使用 <strong>AirDroper</strong>批量发送工具。</h1>
          <p className="description">
            你可以使用 <b>AirDroper</b> 批量转账以太币或ERC20代币，
            一键完成大量地址的代币分发任务。
          </p>
          <Form className="form">
            <div className="form-inline">
              <div className="form-inline-i form-inline-i_token-address">
                <label htmlFor="token-address" className="label">下拉选择币种，或输入代币地址</label>
                <Select.Creatable
              
              isLoading={this.web3Store.loading}
              name="form-field-name"
              id="token-address"
              value={this.state.tokenAddress}
              onChange={this.onTokenAddress}
              loadingPlaceholder="获取代币信息..."
              placeholder="请选择币种或输入代币地址"
              options={this.web3Store.userTokens.slice()}
            />
                
              </div>
              <div className="form-inline-i form-inline-i_token-decimals">
                <label htmlFor="token-decimals" className="label">小数位数</label>
                <Input disabled={this.web3Store.loading} type="text" validations={[required]} onChange={this.onDecimalsChange} value={this.tokenStore.decimals} className="input" id="token-decimals"  readOnly="readonly"/>
              </div>
            </div>
            
            {/*<label htmlFor="addresses-with-balances" className="label">Addresses with Balances in
            <RadioGroup name="format" selectedValue={this.state.format} onChange={this.onSelectFormat}>
              <Radio value="csv" />CSV
              <Radio value="json" />JSON
            </RadioGroup>            
            </label>*/}
            <label htmlFor="addresses-with-balances" className="label">
              输入转账数据
              <p className="info">
                一行表示一条转账，目标地址在前，转账数量在后，中间用逗号隔开。
              </p>
            </label>
            <Textarea 
              style={{'marginBottom': '0px', resize: 'vertical', 'fontFamily': 'consolas'}}
              disabled={this.web3Store.loading}
              data-gram 
              validations={[required]}
              placeholder={`${this.state.placeholder}`}
              value={this.web3Store.taskList}
              onBlur={this.onParse} id="addresses-with-balances" className="textarea"></Textarea>
              
            <div className="data-tools">
              <a href="#" className="action" onClick={this.onPopulateSampleData}>查看示例数据</a> | 
              <a href="#" className="action" onClick={this.onUploadData}>上传文件</a> |                
              <a href="#" className="action" onClick={this.onClearData}>清空数据</a>                 
              <input type="file" ref="uploadButton" onChange={this.onFileChange}/>
            </div>
              
            <Button onClick={this.onSubmit} className="button button_next">下一步</Button>
          </Form>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/1.js